export default "__VITE_ASSET__cGtI2OWL__"